// extracted by mini-css-extract-plugin
export default {"root":"VoteModal_root__f1sWS","header":"VoteModal_header__3pLTq","count":"VoteModal_count__Y+1PQ","button":"VoteModal_button__YvYUC"};